import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';

/**
 * # User
 *
 * 사용자 정보 모델
 */

export const MedicalQuestionComplete = types.model('MedicalQuestionComplete', {
  medQstTypeCd: types.maybeNull(CommonCd),
  medicalQuestionCompleteYn: types.maybeNull(types.string),
});
type TMedicalQuestionComplete = Instance<typeof MedicalQuestionComplete>;
export interface IMedicalQuestionComplete extends TMedicalQuestionComplete {}
export const createMedicalQuestionComplete = () =>
  types.optional(MedicalQuestionComplete, {} as TMedicalQuestionComplete);

export const DrugQuestionComplete = types.model('DrugQuestionComplete', {
  drugQstTypeCd: types.maybeNull(CommonCd),
  drugQuestionCompleteYn: types.maybeNull(types.string),
});
type TDrugQuestionComplete = Instance<typeof DrugQuestionComplete>;
export interface IDrugQuestionComplete extends TDrugQuestionComplete {}
export const createDrugQuestionComplete = () =>
  types.optional(DrugQuestionComplete, {} as TDrugQuestionComplete);

export const HsptlInfo = types.model('HsptlInfo', {
  hsptlSid: types.maybeNull(types.number),
  hsptlNm: types.maybeNull(types.string),
});
type THsptlInfo = Instance<typeof HsptlInfo>;
export interface IHsptlInfo extends THsptlInfo {}
export const createHsptlInfo = () => types.optional(HsptlInfo, {} as THsptlInfo);

export const User = types
  .model('User')
  // --------------------------------------------------------------------------
  .props({
    userSid: types.number,
    loginId: types.maybeNull(types.string),
    pwd: types.maybeNull(types.string),
    userNm: types.maybeNull(types.string),
    phoneNo: types.maybeNull(types.string),
    birthday: types.maybeNull(types.string),
    ci: types.maybeNull(types.string),
    genderTypeCd: types.maybeNull(CommonCd),
    userTypeCd: types.maybeNull(CommonCd),
    quitDt: types.maybeNull(types.string),
    acntSttsCd: types.maybeNull(CommonCd),
    acntSttsDt: types.maybeNull(types.string),
    loginFailCnt: types.maybeNull(types.number),
    pwdUpdDt: types.maybeNull(types.string),
    lastLoginDt: types.maybeNull(types.string),
    regDt: types.maybeNull(types.string),
    updDt: types.maybeNull(types.string),
    deviceToken: types.maybeNull(types.string),
    prescriptionId: types.maybeNull(types.string),
    verifyKey: types.maybeNull(types.string),
    newPwd: types.maybeNull(types.string),
    confirmPwd: types.maybeNull(types.string),
    ftndCompleteYn: types.maybeNull(types.string),
    medicalQuestionCompleteYn: types.maybeNull(types.array(MedicalQuestionComplete)),
    drugQuestionCompleteYn: types.maybeNull(types.array(DrugQuestionComplete)),
    hsptlInfo: types.maybeNull(HsptlInfo),
    langCd: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model user --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IUser;
      (Object.keys(newProps) as TUserKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUser = Instance<typeof User>;
type TUserSnapshot = SnapshotOut<typeof User>;

export interface IUser extends TUser {}
export type TUserKeys = keyof TUserSnapshot & string;
export interface IUserSnapshot extends TUserSnapshot {}
export const createUser = () => types.optional(User, {} as TUser);
